import supabaseClient from '@/api/supabaseClient.ts';
import { FunctionsHttpError, SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { BackendSuccessResponse } from '@/types/response/BackendSuccessResponse';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';
import { ResendVerificationCodeRequest } from '$/requests/ResendVerificationCode.ts';

const useResendVerificationCode = () => {
  const client = supabaseClient;

  const mutationFn = async (request: ResendVerificationCodeRequest) => {
    return resendCode(client, request);
  };

  return useMutation({
    mutationFn,
  });
};

export default useResendVerificationCode;

async function resendCode(
  client: SupabaseClient,
  request: ResendVerificationCodeRequest
): Promise<BackendSuccessResponse<{ message: string }>> {
  const { data, error } = await client.functions.invoke('resend_verification_code', {
    body: { ...request },
  });

  if (error && error instanceof FunctionsHttpError) {
    let message = 'An unexpected error occurred';
    try {
      const errorResponse: BackendErrorResponse = await error.context.json();
      if (Array.isArray(errorResponse?.errors)) {
        message = errorResponse.errors.join(', ');
      } else if (typeof errorResponse?.errors === 'string') {
        message = errorResponse.errors;
      }
    } catch {
      // Response was not valid JSON
    }
    throw new Error(message);
  }

  return data;
}
